import { createListFromObject } from "../../Utilities/Types/listUtilities";

export const CHECKIN_TYPES = {
    Available: "available",
    CheckedOut: "checkedOut",
    Purged: "purged",
};

///TODO: seems like this exists
export const CHECKIN_TITLES = {
    "Available": 0,
    "CheckedOut": 1,
    "Damaged": 2,
    "Missing": 3,
    "Purged": 4,
    "OnOrder": 5,
    "ReOrder": 6,
};

export const CHECKIN_TITLES_LIST = createListFromObject(CHECKIN_TITLES);

export const CHECKIN_TYPES_LIST = createListFromObject(CHECKIN_TYPES);